import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AccountService {

  constructor(
    private http: HttpClient
  ) { }

  checkMobile(model) {
    return this.http.post(environment.baseUrl + `Preregistration_CheckMobile`, model);
  }

  otpCheck(model) {
    return this.http.post(environment.baseUrl + `Preregistration_CheckOTP`, model);
  }

  tankerGPSType() {
    return this.http.post(environment.baseUrl + `Tanker_GPSType_List`, null);
  }

  myRegistrations(model) {
    return this.http.post(environment.baseUrl + `Preregistration_MySelf`, model);
  }

  otpAgain(model) {
    return this.http.post(environment.baseUrl + `Preregistration_ReSendOTP`, model);
  }

  register(model) {
    return this.http.post(environment.baseUrl + `Tanker_Preregistration_Save`, model);
  }

  update_UserInfo(model) {
    return this.http.post(environment.baseUrl + `Tanker_Preregistration_Update`, model);
  }

  specialistLogin(model) {
    return this.http.post(environment.baseUrl + `Preregistration_Login4Admin`, model);
  }

  specialistRegistration(model) {
    return this.http.post(environment.baseUrl + `Tanker_Preregistration_Save4Admin`, model);
  }

  specialistChangePassword(model) {
    return this.http.post(environment.baseUrl + `Preregistration_ChangePassword4Admin`, model);
  }

  specialistForgetPassword(model) {
    return this.http.post(environment.baseUrl + `Preregistration_ForgetPassword`, model);
  }

  specialistCheckMobile(model) {
    return this.http.post(environment.baseUrl + `Preregistration_CheckMobile4Admin`, model);
  }

  appAbility() {
    return this.http.post(environment.baseUrl + `Dyar_GetAppAbility`, {});
  }

  GetState() {
    return this.http.post(environment.baseUrl + `TankerGPS_State_List`, {});
  }

  floatingType() {
    return this.http.post(environment.baseUrl + `FloatingType_List`, {});
  }

  GetCity(code) {
    return this.http.post(environment.baseUrl + `TankerGPS_City_List4State?strState=${code}`, {});
  }

  GetCityNew(code) {
    return this.http.post(environment.baseUrl + `GetCity2?strSate=${code}`, {});
  }

  checkOtp(hpnumber, otp) {
    return this.http.post(environment.baseUrl + 'App_CheckRegisterOTP', {
      strMobile: hpnumber,
      strActivateCode: otp,
    });
  }

  ReverseGeocoding(fLon, fLat) {
    var model = {
      fLon: fLon,
      fLat: fLat,
    };
    return this.http.post(environment.baseUrl + `ReverseGeocoding`, model);
  }

  GetUserAbility(model) {
    return this.http.post(environment.baseUrl + `GetUserAbility`, model);
  }

  tankerInvoice(model) {
    return this.http.post(environment.baseUrl + `Tanker_Invoice`, model);
  }

  payInvoice(model) {
    return this.http.post(environment.baseUrl + `Tanker_PayInvoice`, model);
  }

  preInvoiceDetail(model) {
    return this.http.post(environment.baseUrl + `Tanker_PreInvoiceDetail`, model);
  }

  checkout_payment(model) {
    return this.http.post(environment.baseUrl + `Tanker_CheckPayment`, model);
  }

  userInfo(model) {
    return this.http.post(environment.baseUrl + `Preregistration_Info`, model);
  }

  toastSwal(type, title) {
    Swal.fire({
      position: 'bottom-end',
      icon: type,
      toast: true,
      background:
        type == 'success' ? '#008631' : type == 'error' ? '#DF1C24' : type == 'warning' ? '#54c3e6' : '#3fc3ee',
      color: '#fff',
      timerProgressBar: true,
      title,
      customClass: {
        title: 'toaster-lineSpacing',
      },
      showConfirmButton: false,
      timer: 3000
    });
  }
}
